export default __webpack_public_path__ + "static/cafe cup-7d42f706410c775b5194e33983fde070.png";